var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.5 38.5",
    id: "instagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.89,
    x2: 31.61,
    y1: 4.52,
    y2: 33.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ffbb36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ff5176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f63395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a436d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f4eed"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M38.5,19.25c0,5.29-2.16,10.11-5.65,13.6s-8.31,5.65-13.6,5.65c-1.27,0-2.52-.13-3.73-.36C6.7,36.39,0,28.57,0,19.25c0-5.29,2.16-10.11,5.65-13.6S13.96,0,19.25,0s10.11,2.16,13.6,5.65c2.63,2.63,4.5,6.01,5.27,9.77.25,1.24.38,2.52.38,3.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d75fff",
    d: "M38.5,19.25c0,5.29-2.16,10.11-5.65,13.6s-8.31,5.65-13.6,5.65c-1.27,0-2.52-.13-3.73-.36-2.49-2.47-4.96-4.93-7.44-7.4-1.59-1.51-2.59-3.64-2.59-6v-10.98c0-4.56,3.71-8.27,8.27-8.27h10.98c2.36,0,4.48.99,5.98,2.57,2.47,2.45,4.94,4.91,7.4,7.36.25,1.24.38,2.52.38,3.83Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.54 10.4c-.89 0-1.61.72-1.61 1.61s.72 1.61 1.61 1.61 1.61-.72 1.61-1.61-.72-1.61-1.61-1.61zM19.36 12.47c-3.74 0-6.78 3.04-6.78 6.78s3.04 6.78 6.78 6.78 6.78-3.04 6.78-6.78-3.04-6.78-6.78-6.78zM19.36 23.59c-2.39 0-4.34-1.95-4.34-4.34s1.95-4.34 4.34-4.34 4.34 1.95 4.34 4.34-1.95 4.34-4.34 4.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.74,33.01h-10.99c-4.56,0-8.27-3.71-8.27-8.27v-10.99c0-4.56,3.71-8.27,8.27-8.27h10.99c4.56,0,8.27,3.71,8.27,8.27v10.99c0,4.56-3.71,8.27-8.27,8.27ZM13.76,8.08c-3.13,0-5.68,2.55-5.68,5.68v10.99c0,3.13,2.55,5.68,5.68,5.68h10.99c3.13,0,5.68-2.55,5.68-5.68v-10.99c0-3.13-2.55-5.68-5.68-5.68h-10.99Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cbceac78f2b44e7c900dd4efc854b46d.svg";
export { ForwardRef as ReactComponent };